
class Config {

  public baseURL: string = process.env.VUE_APP_API

  /**
   * 本地开发时用的 token
   */
  private localToken: string = 'bearer a219aab6-b55e-426d-aaaf-d95d7bffad5c'

  /**
   * 获取 token 拼接
   */
  public token() {
    // if (process.env.VUE_APP_ENV == 'local' ) {
    //   return this.localToken
    // } else {
      const token = JSON.parse(localStorage.getItem('token')) || ''
      if (token) {
        return token.token_type + ' ' + token.access_token
      }
    // }
  }
}

let config = new Config()

export default config
